import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizButton } from '../../components/controls/button/wiz-button/wiz-button';
import { Observable } from 'rxjs';


// donnée de construction d'un bouton de la barre de navigation
export class WizActionObj {

  public uuid: string = WizMathUtils.createUUID();

  public buttonCode: string; // code du bouton, pour gestion sur callback standard
  public imageSource: string; // origine de l'icône
  public callbackMethod: Function; // fonction maitresse de la vue d'origine
  public classFactory: any = WizButton; // classe de référence (classFactory) pour le rendu, defaut = WizDefaultButton
  public disabled: boolean = false; // activé ou pas ?
  public refreshMethod: Function = null; // point d'entrée pour injecter des modifs
  public width: string = null;
  public height: string  = null;
  public label: string  = null;
  // public moreArgs: {} = null;
  public value: any= null;
  public validationRequired: boolean = false;

  public kind: string = null; // type de tab
  public featureCode: string = null; // la fonctionnalité correpondante
  public order: number = 0; // l'ordre dans la tabbar
  
  public viewOrder: number = 0; // l'ordre dans la vue de choix des vue

  public imgObs: Observable<string> = null; // passage de l'image en observable


  // l'ordre dans la vue des tabs
  // public get viewOrder(): number {
  //   return this.data?.viewOrder || 0;
  // }

  // public set viewOrder(value: number) {
  //   // rien 
  // }

  public lineColor: string = null; // la couleur du liseré
  public description: string = null; // la description pour le tooltip
  public data: any = null; // la conf de navigation (navigationParameter ou TabVO)

  public showDelete: boolean = true; // afficher la croix de suppression

  constructor(
    buttonCode: string, // code du bouton, pour gestion sur callback standard
    imageSource: string, // origine de l'icône
    callbackMethod: Function, // fonction maitresse de la vue d'origine
    classFactory: any = WizButton , // classe de référence (classFactory) pour le rendu, defaut = WizDefaultButton
    disabled: boolean = false, // activé ou pas ?
    refreshMethod: Function = null, // point d'entrée pour injecter des modifs
    width: string = null,
    height: string  = null,
    label: string  = null,
    // moreArgs: {} = null,
    value: any= null,
    validationRequired: boolean = false,
    showDelete: boolean = true,
    //description: string
  ) {

    this.buttonCode = buttonCode;
    this.imageSource = imageSource;
    this.callbackMethod = callbackMethod;
    this.classFactory = classFactory;
    this.disabled = disabled;
    this.refreshMethod = refreshMethod;
    this.width = width;
    this.height = height;
    this.label = label;
    this.value = value;
    this.validationRequired = validationRequired;
    this.showDelete = showDelete;
    //this.description = description;
  }


  // TODO LMA peut pas marcher sur le wizButton...

  /**
   * ajout des arguments complémentaires
   * @param featureCode
   * @param order
   * @param viewOrder
   * @param lineColor
   * @param description
   * @param data
   */
  // public moreActionArgs(kind: string = null, featureCode: string = null, order: number = 0, viewOrder: number = 0, lineColor: string = null, description: string = null, data: any = null) {
  //   this.kind = kind;
  //   this.featureCode = featureCode;
  //   this.order = order;
  //   this.viewOrder = viewOrder;
  //   this.lineColor = lineColor;
  //   this.description = description;
  //   this.data = data;
  // }
}
